import { call, takeLeading } from 'redux-saga/effects';
import { AdminOrganizationsAutoComplete } from 'api';
import { getNextPageParams, sagasHandlersFactory } from 'store/entities/utils';
import * as actions from './actions';
import * as selectors from './selectors';

const handleGetAdminOrganizationsParentAutoCompleteRequest = sagasHandlersFactory.createGetManyRequestHandler({
  actions: actions.getAdminOrganizationsParentAutoComplete,
  request: AdminOrganizationsAutoComplete.getOrganizationParentAutoComplete,
  requestArgsBuilder: function* builder(action) {
    const { params } = action.payload;
    const { page_size, ...rest } = params;
    const { page } = yield call(
      getNextPageParams,
      page_size,
      selectors.adminOrganizationsParentAutoCompleteState,
      params,
    );
    return [{ params: { ...rest, page, page_size } }];
  },
});

export default function* adminOrganizationsParentAutocompleteSagas() {
  yield takeLeading(
    actions.getAdminOrganizationsParentAutoComplete.request.type,
    handleGetAdminOrganizationsParentAutoCompleteRequest,
  );
}
